import {main} from "./ts/main";
import {COMPONENT} from "./constant/COMPONENT";

export const index = {
    main: main,
    COMPONENT: COMPONENT
}